import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  isElder: 'normal'// 是否适老化
}

const mutations = {
  SET_elder: (state, elder) => {
    state.isElder = elder
  }
}

const getters = {
  // 是否老年化
  isElder: state => {
    return state.isElder
  }
}

const actions = {

}
export default new Vuex.Store({
  state, // 存放所有状态变量
  mutations, // 存放更新state函数的对象
  actions, // 存放事件函数对象
  getters, // 存放计算属性
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js